import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const CheckRoute = (props: any) => {
    const { children } = props;
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!searchParams.get('nIDRestaurant')) {
            navigate('/');
        }
    }, [searchParams, navigate]);

    return children;
}

export default CheckRoute;